// extracted by mini-css-extract-plugin
export default {"PublicLayout":"PublicLayout_PublicLayout__qUzjS","ScrollbarBox":"PublicLayout_ScrollbarBox__ey2WL","container":"PublicLayout_container__qV6sO"};